export default "__VITE_ASSET__D7hB3Wfc__"